import React from 'react';
import { Path, Rect, Circle, Line, Polygon, Polyline, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const PhoneIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M7 2.75H9M4 16.75H12C12.5523 16.75 13 16.3023 13 15.75V1.75C13 1.19772 12.5523 0.75 12 0.75H4C3.44772 0.75 3 1.19772 3 1.75V15.75C3 16.3023 3.44772 16.75 4 16.75Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

PhoneIcon.displayName = 'PhoneIcon';
